export enum TipoPlanoEnum  {
  QUITACAO = 'QUITACAO',
  PARCELADO = 'PARCELADO'
}

export enum OrigemPlanoEnum  {
  CYBER = 'CYBER',
  ESPECIAL = 'ESPECIAL',
  MASSIVO = 'MASSIVO'
}


export interface NovoPlanoInformacoesComplementares {
  idPropostaMassiva?: string;
  valorMaximoEntrada: number;
  valorMinimoEntrada: number;
  valorSaldoPrincipal: number;
  dataMaximoEntrada: string;
  dataMinimoEntrada: string;
}

export class NovoPlanoRenegociacao {
  id?: string;
  tipo: TipoPlanoEnum;
  origem: OrigemPlanoEnum;
  valor: number;
  parcelas: number;
  valorEntrada: number;
  destaque: boolean;
  informacoesComplementares?: NovoPlanoInformacoesComplementares;
}
